module.exports = "/_next/static/images/c5a7cadbc15f3af49e65c3d7877428de-msi-lg.png";